module.exports = __webpack_public_path__ + "img/report-5.708cc108.jpg";